import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IconLogout, IconSearch, IconSettings } from "@/components/ui/icons";
import { VerifiedBadge } from "@/components/ui/VerifiedBadge";
import { SettingsModal } from "@/components/account/SettingsModal";
import { useAuth } from "@/hooks/useAuth";
import { useIsMobile } from "@/hooks/useIsMobile";
import { AvailabilityIndicator } from "./AvailabilityIndicator";
import { NotificationsBell } from "./NotificationsBell";
import { SearchSuggestions } from "./SearchSuggestions";

export function TopBar() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const isMobile = useIsMobile(800);
  const [q, setQ] = useState("");
  const [focused, setFocused] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const on = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        (document.getElementById("topbar-search") as HTMLInputElement | null)?.focus();
      }
    };
    window.addEventListener("keydown", on);
    return () => window.removeEventListener("keydown", on);
  }, []);

  return (
    <header style={{
      height: "100%", display: "flex", alignItems: "center",
      padding: isMobile ? "0 18px 0 12px" : "0 16px",
      gap: isMobile ? 8 : 10,
    }}>
      {isMobile && (
        <Link to="/" aria-label="Accueil" style={{
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          width: 34, height: 34, flexShrink: 0,
        }}>
          <img src="/favicon-v2.svg" width={26} height={26} alt="sonslow" />
        </Link>
      )}
      <div className="row grow" style={{
        maxWidth: isMobile ? undefined : 520,
        position: "relative",
        minWidth: 0,  /* let the search shrink instead of pushing the settings gear off-viewport */
      }}>
        <IconSearch />
        <input
          id="topbar-search"
          className="topbar-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setTimeout(() => setFocused(false), 150)}
          onKeyDown={(e) => { if (e.key === "Enter") nav(`/search?q=${encodeURIComponent(q)}`); }}
          placeholder="Chercher…"
          style={{
            marginLeft: 8, flex: 1, background: "var(--bg-elev)",
            border: "1px solid var(--line)", borderRadius: 999,
            padding: "10px 14px", outline: "none", minWidth: 0,
          }}
        />
        {focused && q.length > 0 && <SearchSuggestions query={q} onPick={(s) => { setQ(s); nav(`/search?q=${encodeURIComponent(s)}`); }} />}
      </div>
      {!isMobile && <div className="grow" />}
      <AvailabilityIndicator />
      <span className="topbar-user-label" style={{ marginLeft: 12, display: "inline-flex", alignItems: "center", gap: 6 }}>
        <span className="muted">{user?.display_name || user?.username}</span>
        {user?.email_verified && <VerifiedBadge />}
      </span>
      <NotificationsBell />
      <button className="btn ghost" title="Paramètres" onClick={() => setSettingsOpen(true)}
              style={{ marginLeft: 6, flexShrink: 0 }}>
        <IconSettings />
      </button>
      {!isMobile && (
        <button className="btn ghost" title="Se déconnecter" onClick={() => void logout()}>
          <IconLogout />
        </button>
      )}
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </header>
  );
}
